import React, { useEffect, useState } from 'react';
import popimg from "../../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../../Common/Images/ImagesForAlert/popup_close_n.png";
import { useNavigate } from 'react-router-dom';
import Loading from "../../Common/Loading"

const YEAR_OPTIONS = ['ALL', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

const API_BASE = process.env.REACT_APP_DOCUMENT_LINK;

const MD_ValidateQnTypes: React.FC = () => {
  const [curriculums, setCurriculums] = useState<string[]>([]);
  const [selectedCurriculum, setSelectedCurriculum] = useState('');
  const [selectedYear, setSelectedYear] = useState('ALL');
  const [showBackButton, setShowBackButton] = useState(false);
  const [isRunning, setIsRunning] = useState(false);
  const [isLoadingInit, setIsLoadingInit] = useState(true);

  const navigate = useNavigate()

  useEffect(() => {
    document.body.style.backgroundColor = "azure"
  })

  useEffect(() => {
    fetch(`${API_BASE}/api/md-validate-qn-types/init/`, { credentials: 'include' })
      .then((res) => res.json())
      .then((data) => {
        const list: string[] = data.curriculums || [];
        setCurriculums(list);
        if (list.length > 0) {
          setSelectedCurriculum(list[0]);
        }
        setShowBackButton(!!data.showBackButton);
      })
      .catch(() => {
        window.alert('Failed to load page data.');
      })
      .finally(() => {
        setIsLoadingInit(false);
      });
  }, []);

  const handleGO = async () => {
    if (!selectedCurriculum) return;
    setIsRunning(true);
    try {
      const body = new URLSearchParams();
      body.append('curriculum', selectedCurriculum);
      body.append('year', selectedYear);

      const res = await fetch(`${API_BASE}/api/md-validate-qn-types/run/`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      const data = await res.json();

      // Mirrors fn_StartValidation: ErrorMesg shown first, then AlertMesg.
      if (data.errorMesg) {
        window.alert(data.errorMesg);
      } else if (data.alertMesg) {
        window.alert(data.alertMesg);
      }
    } catch (ex) {
      window.alert('An unexpected error occurred while validating question types.');
    } finally {
      setIsRunning(false);
    }
  };

  const handleBack = () => {
    // Mirrors btnBack_Click: target depends on SES_SupportLogin.
    // TODO: point these at your actual React routes for SupportLogin / SysAdminNew.
    if (showBackButton) {
      window.location.href = '/support/support-login';
    } else {
      window.location.href = '/SysAdmin';
    }
  };

  if (isLoadingInit) {
    return <Loading />;
  }

  return (

    <><div
      style={{
        backgroundImage: `url(${popimg}), url(${popbg})`,
        backgroundRepeat: "no-repeat, no-repeat",
        backgroundPosition: "left center, right center",
        backgroundSize: "30% 100%, 70% 100%",
        height: "16px",
        color: "white",
        padding: "7px 0px",
        fontWeight: "bold",
        fontSize: "12pt",
        fontFamily: "arial",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "10px",
      }}
    >
      <span style={{ marginLeft: "10px" }}>
        Validate MD question types
      </span>
      <img
        src={popclose}
        alt="close"
        height="30px"
        style={{ cursor: "pointer" }}
        onClick={() => window.close()} />
    </div><div style={{ fontFamily: 'Arial', fontSize: '14pt', paddingLeft:"10px" }}>
        <style>{`
        .mdvqt-dropdown {
          border: solid 1px #003300;
          font-family: Arial;
          font-size: 14pt;
        }
        .mdvqt-button {
          font-family: Arial;
          font-size: 14pt;
        }
      `}</style>

        Curriculum:&nbsp;
        <select
          className="mdvqt-dropdown"
          style={{ height: '25px', width: '166px' }}
          value={selectedCurriculum}
          onChange={(e) => setSelectedCurriculum(e.target.value)}
        >
          {curriculums.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Year:
        <select
          className="mdvqt-dropdown"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
        >
          {YEAR_OPTIONS.map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

        <button className="mdvqt-button" onClick={handleGO} disabled={isRunning}>
          {' GO '}
        </button>
        {showBackButton && (
          <button className="mdvqt-button" style={{ float: 'right' }} onClick={handleBack}>
            back
          </button>
        )}
        {isRunning && <Loading />}
      </div></>
  );
};

export default MD_ValidateQnTypes;